export const artists = {
  pageTitle: 'Artist Directory',
  pageSubtitle: 'Find the perfect live music talent for your event in Las Vegas',
  searchPlaceholder: 'Search by artist name, genre, or event type...',
  resultsCount: '{{count}} artists found',
  noResults: 'No artists found matching your criteria',
  clearFilters: 'Clear filters',
  filters: {
    category: 'Category',
    genre: 'Genre',
    eventType: 'Event Type',
    all: 'All',
  },
  sort: {
    label: 'Sort by',
    featured: 'Featured first',
    name: 'Name A-Z',
    category: 'Category',
  },
  card: {
    viewProfile: 'View Profile',
    contact: 'Contact',
    phone: 'Phone',
    email: 'Email',
    website: 'Website',
    genres: 'Genres',
    events: 'Events',
    bio: 'Bio',
  },
  categories: {
    soloists: 'Soloists',
    duos: 'Duos',
    trios: 'Trios',
    quartets: 'Quartets',
    quintets: 'Quintets',
    sextets: 'Sextets',
    fullBand: 'Full Band',
  },
  events: {
    weddings: 'Weddings',
    corporateEvents: 'Corporate Events',
    privateParties: 'Private Parties',
    galas: 'Galas',
    receptions: 'Receptions',
    networking: 'Networking',
    specialCelebrations: 'Special Celebrations',
  },
};

export default artists;